import {config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverLoanHistoryApi {
    static getLoanHistories(loanHistorySearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(loanHistorySearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}loan/history?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static getStudents(studentSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(studentSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}students/patrons?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static getListsForDropDowns(systemType: string | number) {
        return sendRequest(
            requestOptions(config.URL + `loan/${systemType}/dropdown-lists`,
                requestTypes.GET,
            ),
        );
    }
}

export const loanHistoryApi = config.environment.MODE === config.modes.SERVER ? serverLoanHistoryApi : serverLoanHistoryApi;
